__turbopack_context__.v({
  "anchor": "OutfittingAnchor-module-scss-module__aFvCEW__anchor",
  "arrow": "OutfittingAnchor-module-scss-module__aFvCEW__arrow",
  "body": "OutfittingAnchor-module-scss-module__aFvCEW__body",
  "content": "OutfittingAnchor-module-scss-module__aFvCEW__content",
  "heading": "OutfittingAnchor-module-scss-module__aFvCEW__heading",
  "icon": "OutfittingAnchor-module-scss-module__aFvCEW__icon",
});
